import React from "react";
import NextImage from "next/image";
// components
import { Wrapper, Title, LabelsWrapper, LabelContainer, Icon, Label } from "./knownFor.styles";

const KnownForContainer = ({ reasons }: any) => {
  return (
    <Wrapper>
      <Title>Known for</Title>

      <LabelsWrapper>
        {reasons.map((reason: any, index: any) => (
          <LabelContainer key={index}>
            <Label>{reason}</Label>
          </LabelContainer>
        ))}
        {/* <LabelContainer>
          <Icon>
            <NextImage src="/icons/Smile.svg" width={20} height={20} />
          </Icon>
          <Label>Friendly service</Label>
        </LabelContainer> */}
      </LabelsWrapper>
    </Wrapper>
  );
};

export default KnownForContainer;
